import React from "react";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import {
  AppBar,
  Toolbar,
  Button,
  Avatar,
  makeStyles,
  Box,
} from "@material-ui/core";
import "./style.scss";
import { FontWeights, FontColors } from "theme/fontConfig";

const useStyles = makeStyles((theme) => ({
  appBar: {
    background: "transparent",
    boxShadow: "none",
    borderRadius: 12,
  },
  toolbar: {
    minHeight: 80,
    paddingLeft: 12,
    paddingRight: 12,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  logoWrap: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    gap: 12,
    textDecoration: "none",
  },
  logoImg: {
    width: 130,
    height: 50,
    objectFit: "contain",
    borderRadius: 6,
  },
  logoutPill: {
    borderRadius: 999,
    paddingLeft: 16,
    paddingRight: 16,
    minHeight: 36,
    textTransform: "none",
    fontWeight: FontWeights.SemiBold,
    boxShadow: "none",
  },
  logoutDark: {
    background: "rgb(37, 85, 239)",
    color: FontColors.White,
    "&:hover": {
      background: "rgb(0 54 227)",
    },
  },
  logoutIconOnly: {
    width: 40,
    height: 40,
    borderRadius: 999,
  },
}));

export default function Header({ origin = {}, logoutIcon: LogoutIcon }) {
  const classes = useClassesSafe(useStyles);

  const handleLogout = () => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("hasPayment");
      localStorage.removeItem("userAuthData");
      window.location.reload();
    } catch (e) {
      // ignore storage errors
    }
  };

  return (
    <header className="minimal-header-wrap">
      <AppBar position="static" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <div
            className={classes.logoWrap}
            role="button"
            onClick={() => (window.location.href = "/")}
            aria-label="home"
          >
            {origin?.logoImg ? (
              <img
                src={origin.logoImg}
                alt={origin?.name ?? "logo"}
                className={classes.logoImg}
              />
            ) : (
              <Avatar style={{ width: 36, height: 36 }}>
                {(origin?.name || "A").charAt(0)}
              </Avatar>
            )}
          </div>

          <Box sx={{ mr: 2 }}>
            <Button
              onClick={handleLogout}
              variant="contained"
              startIcon={LogoutIcon ? <LogoutIcon /> : <ExitToAppIcon />}
              className={`${classes.logoutPill} ${classes.logoutDark}`}
              aria-label="logout"
            >
              Logout
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
    </header>
  );
}

function useClassesSafe(hook) {
  try {
    return hook();
  } catch (e) {
    return {};
  }
}
